import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getInquiries, markInquiryRead, deleteInquiry } from '../../services/adminService';

export default function AdminInquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const load = () => getInquiries().then(d => { setInquiries(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleRead = async (id) => {
    await markInquiryRead(id);
    setInquiries(prev => prev.map(i => i.id === id ? { ...i, read: true } : i));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this inquiry?')) return;
    await deleteInquiry(id);
    setInquiries(prev => prev.filter(i => i.id !== id));
  };

  const fmt = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const filtered = filter === 'all' ? inquiries : inquiries.filter(i => i.source === filter || (filter === 'unread' && !i.read));

  return (
    <AdminLayout title="Inquiries">
      <div className="admin-tabs">
        {['all', 'enquiry', 'contact', 'unread'].map(f => (
          <button key={f} className={`admin-tab${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>
            {f === 'all' ? `All (${inquiries.length})` : f === 'unread' ? `Unread (${inquiries.filter(i => !i.read).length})` : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div className="admin-section">
        {loading ? <div className="admin-spinner">Loading…</div> : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr><th>Name</th><th>Contact</th><th>Details</th><th>Source</th><th>Date</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {filtered.map(inq => (
                  <tr key={inq.id}>
                    <td><strong>{inq.name}</strong></td>
                    <td>{inq.contact}</td>
                    <td style={{ maxWidth: 260, fontSize: 13 }}>
                      {inq.service && <div><strong>Service:</strong> {inq.service}</div>}
                      {inq.event_dates && <div><strong>Date:</strong> {inq.event_dates}</div>}
                      {inq.venue && <div><strong>Venue:</strong> {inq.venue}</div>}
                      {inq.bridal_suboptions && <div><strong>Functions:</strong> {inq.bridal_suboptions}</div>}
                      {inq.message && <div>{inq.message}</div>}
                      {inq.desired_time && <div><strong>Call time:</strong> {inq.desired_time}</div>}
                    </td>
                    <td><span className={`badge badge-${inq.source}`}>{inq.source}</span></td>
                    <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmt(inq.createdAt)}</td>
                    <td><span className={`badge badge-${inq.read ? 'read' : 'unread'}`}>{inq.read ? 'Read' : 'New'}</span></td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {!inq.read && (
                          <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => handleRead(inq.id)}>✓ Mark Read</button>
                        )}
                        <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(inq.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={7} className="admin-empty">No inquiries found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
